import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import '../../scss/components/_data_management.scss';




const FileDownloading = props => {
    return (
        <Dialog
                open={props.errorDialogue}
                onClose={props.handleCloseDialogueBox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="delete-popup"
            >
                <DialogContent>
                    <div className="error-container">
                        <img src={require('../../assets/icons/file-downloading-error.svg')} />
                        <div>
                            <label>An error occurred</label>
                            <p>An error occurred while attempting to download the file. Please try again</p>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleCloseDialogueBox} className="blue-btn font-14">
                        Dismiss
            </Button>
                </DialogActions>
        </Dialog>
    )
}

export default FileDownloading;